import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useContext } from 'react';
var PortalContext = /*#__PURE__*/React.createContext(null);

var PromptPortalProvider = function PromptPortalProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(new Map()),
      _useState2 = _slicedToArray(_useState, 2),
      modalMap = _useState2[0],
      setModalMap = _useState2[1];

  var requestToShow = function requestToShow(id, nextModal) {
    setModalMap(function (prevMap) {
      prevMap.set(id, nextModal);
      return new Map(prevMap);
    });
  };

  var closeModal = function closeModal(id) {
    modalMap["delete"](id);
    setModalMap(new Map(modalMap));
  };

  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: {
      requestToShow: requestToShow,
      closeModal: closeModal
    }
  }, children, modalMap.values().next().value);
};

var usePortal = function usePortal() {
  return useContext(PortalContext);
};

export { PromptPortalProvider, usePortal };